export default "__VITE_ASSET__BxxLmN$$__";